import { computed } from '@ember/object';
import { isNone } from '@ember/utils';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export const FRACTIONAL_DENOMINATOR = 100000;
export default ProtoBaseModel.extend({
  count: attr(Number),
  fractionalCount: attr(Number),
  countFormatted: computed('count', 'fractionalCount', function () {
    const totalFractionalCount = (this.count === undefined ? 0 : this.count) * FRACTIONAL_DENOMINATOR + (this.fractionalCount === undefined ? 0 : this.fractionalCount);
    const count = Math.floor(totalFractionalCount / FRACTIONAL_DENOMINATOR);
    return count;
  }),
  add(other) {
    if (isNone(other)) {
      return this.constructor.createWithCount(this.count, this.fractionalCount);
    }
    let totalFractionalCount = (this.count === undefined ? 0 : this.count) * FRACTIONAL_DENOMINATOR + (this.fractionalCount === undefined ? 0 : this.fractionalCount);
    totalFractionalCount += other.get('count') * FRACTIONAL_DENOMINATOR + (other.get('fractionalCount') === undefined ? 0 : other.get('fractionalCount'));
    const count = Math.floor(totalFractionalCount / FRACTIONAL_DENOMINATOR);
    // Implementing (a mod b) as ((a % b + b) % b),
    // so it would be true that (floor(a / b) * b + (a mod b) == a) even if a is negative.
    const fractionalCount = (totalFractionalCount % FRACTIONAL_DENOMINATOR + FRACTIONAL_DENOMINATOR) % FRACTIONAL_DENOMINATOR;
    return this.constructor.createWithCount(count, fractionalCount);
  }
}).reopenClass({
  createWithCount(count, fractionalCount) {
    const result = this.create();
    if (!isNone(count)) {
      result.set('count', count);
    } else {
      result.set('count', 0);
    }
    if (!isNone(fractionalCount) && fractionalCount !== 0) {
      result.set('fractionalCount', fractionalCount);
    }
    return result;
  }
});